<template>
  <div v-if="hasChargeType" class="dated-status">
    <div v-if="isAvailable && isLowAvailability" class="status">
      <img src="@/assets/images/timer.svg" alt="" width="9" height="15" />
      <translate :tt="{ pitchesToSell }">
        Only {pitchesToSell} left on our site
      </translate>
    </div>
    <div v-if="offersActive" class="status">
      <img
        src="@/assets/images/star-outline.svg"
        alt=""
        width="15"
        height="15"
      />
      <translate
        v-if="Number(offerPercentage) > 0"
        :tt="{ discount: offerPercentage / 100 }"
      >
        {discount, number, percent} off
      </translate>
      <translate v-else>Offer</translate>
    </div>
  </div>
  <div v-else-if="showOffersLosenge" class="undated-status">
    <div class="status">
      <img
        src="@/assets/images/star-outline.svg"
        alt=""
        width="15"
        height="15"
      />
      <translate>Offer</translate>
    </div>
  </div>
  <div v-else />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
@Component
class PitchTypeStatusMsg extends Vue {
  @Prop({ required: true })
  isAvailable: boolean

  @Prop({ required: true })
  hasChargeType: boolean

  @Prop()
  isLowAvailability: boolean

  @Prop()
  offersActive: boolean

  @Prop()
  showOffersLosenge: boolean

  @Prop()
  offerPercentage: number

  @Prop()
  pitchesToSell: number
}

export default toNative(PitchTypeStatusMsg)
</script>

<style scoped>
.status {
  color: var(--colour-offers);
  font-size: var(--small);
  margin-left: 1em;
  display: flex;
  line-height: 1;
}

.status img {
  width: auto;
  height: 1.1em;
  margin-right: 0.25em;
}

.status span {
  flex-shrink: 1;
}

.dated-status {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
</style>
